import template from './radioFormElement.html';
import controller from './radioFormElement.controller';
import './radioFormElement.scss';

let radioFormElementComponent = {
  restrict: 'E',
  bindings: {
    label: '@',
    value: '=',
    options: '<',
    columns: '@',
    name: '@',
    validationError: '<'
  },
  template,
  controller
};

export default radioFormElementComponent;
